import { request } from './helpers/request'
import {
  GENERIC_MFA_ERROR_CODE,
  GENERIC_SERVER_ERROR_CODE,
} from '../constants/error.codes'
import { RECOVERY_OTP, TOTP, WEB_AUTHN } from '../constants/mfa'

const mapMfaMechanismToPath = (mfaMechanism) =>
  ({
    [TOTP]: 'totp',
    [WEB_AUTHN]: 'webauthn',
    [RECOVERY_OTP]: 'otp',
  })[mfaMechanism]

export const revokeMFAMechanism = (data) => {
  const { mfaMechanism, password, recaptchaResponse } = data

  return request({
    method: 'DELETE',
    url: '/users/mfa/' + mapMfaMechanismToPath(mfaMechanism),
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify({ password, recaptchaResponse }),
  }).then((response) => {
    if (response.status === 204) {
      return Promise.resolve(response)
    } else if (response.status >= 400 && response.status < 500) {
      const errorCode =
        response.data.code ||
        (response.data.error && response.data.error.code) ||
        response.data.message ||
        GENERIC_MFA_ERROR_CODE

      return Promise.reject({ code: errorCode })
    } else {
      return Promise.reject(new Error(GENERIC_SERVER_ERROR_CODE))
    }
  })
}
